import React from 'react'

import Breadcrumb from './Breadcrumb';
import Classifiedlisting from './ClassifiedListing';



function ClassifiedPage() {
    return ( 
        <>
       
        <Breadcrumb />
       
        <Classifiedlisting />

        {/* <Herobottom /> */}
     
        </>
     );
}

export default ClassifiedPage;